import React, { useState, useEffect } from "react";
import { Button, Col, DatePicker, Form, Input, Modal, notification, Row, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { expenseVoucherService } from "../../../../../services";
import dayjs from "dayjs";
import MaterialLikeSelect from "../../../../../components/MaterialLikeSelect";
import MaterialLikeInput from "../../../../../components/MaterialLikeInput";
import MaterialLikeDatePicker from "../../../../../components/MaterialLikeDatePicker";
import MaterialLikeTextArea from "../../../../../components/MaterialLikeTextArea ";

function AddExpense({ isVisible, setIsModalShow, vendors, setRefresh, subAccount, expenseAcc, voucher_number }) {

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [filteredSubAccount, setFilteredSubAccount] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [button, setButton] = useState(null);
  const [isSave, setIsSave] = useState(false);

  const handleCancel = (close = false) => {

    if (!close) setRefresh(true);

    form.resetFields();
    setIsSave(false);
    setIsModalShow(false);
  };

  const handleExpChange = (value) => {
    const { vendor_category_id, id } = JSON.parse(value);
    const filteredSubAcc = subAccount.filter(
      (subAccount) => subAccount.expense_category_id === id
    );
    setFilteredSubAccount(filteredSubAcc);
    const filteredVendors = vendors.filter(
      (vendor) => vendor.vendors_categorys_id === vendor_category_id
    );
    setFilteredVendors(filteredVendors);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const expense = JSON.parse(values.expense_category);
    const vendor_cat_id = vendors.find(
      (vendor) => values.vendor == vendor.id
    )?.vendors_categorys_id;
    const data = {
      ...values,
      vendor_category: vendor_cat_id,
      expense_category: expense.id,
      due_date: values.due_date.format("YYYY-MM-DD"),
      voucher_date: values.voucher_date.format("YYYY-MM-DD"),
      is_future: button === "save" ? 1 : 0,
      attachment: values.attachment ? values.attachment : null,
      description: values.description ? values.description : "",
    };
    const response = await expenseVoucherService.addExpense(data);
    if (response.success) {
      notification.success({
        message: "Added Successfully!",
        description: response.message,
        placement: "topRight",
      });
    } else {
      notification.error({
        message: "Error adding",
        description: response.message,
        placement: "topRight",
      });
    }
    setLoading(false);
    handleCancel();
  };

  useEffect(() => {
    form.setFieldsValue({
      voucher_number: voucher_number,
    });
  }, [isVisible]);

  return (
    <Modal
      title={<div style={{ width: "100%" }}>Make Expense</div>}
      open={isVisible}
      onCancel={() => handleCancel(true)}
      footer={null}
      closable={true}
      width={700}
      style={{ padding: "15px" }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        initialValues={{
          due_date: dayjs().tz(),
          voucher_date: dayjs().tz(),
        }}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="expense_category"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Expense Account"
                required
                value={form.getFieldValue("expense_category")}
                onChange={(value) => {
                  handleExpChange(value); // same as your previous onChange logic
                  form.setFieldValue("expense_category", value);
                }}
                options={expenseAcc?.map((expense) => ({
                  id: expense.id,
                  value: JSON.stringify(expense), // stringify object for Select compatibility
                  label: expense.name,
                }))}
              />
              {/* <Select
                placeholder="Select Inter-Company"
                onChange={(value) => handleExpChange(value)}
              >
                {expenseAcc.map((expense) => (
                  <Select.Option
                    key={expense.id}
                    value={JSON.stringify(expense)}
                  >
                    {expense.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="expense_subcategory"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Sub-Account"
                required
                value={form.getFieldValue("expense_subcategory")}
                onChange={(value) => form.setFieldValue('expense_subcategory', value)}
                options={filteredSubAccount?.map((subacc) => ({
                  id: subacc.id,
                  value: subacc.id,
                  label: subacc.name
                }))}
              />
              {/* <Select placeholder="Select Inter-Company">
                {filteredSubAccount.map((subacc) => (
                  <Select.Option key={subacc.id} value={subacc.id}>
                    {subacc.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="voucher_number"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <MaterialLikeInput
                label="Voucher Number"
                required
                value={form.getFieldValue("voucher_number")}
                onChange={(e) => form.setFieldValue("voucher_number", e.target.value)}
                readOnly
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="voucher_date"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <MaterialLikeDatePicker
                label="Voucher Date"
                required
                value={form.getFieldValue("voucher_date")}
                onChange={(date) => form.setFieldValue("voucher_date", date)}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="vendor"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Vendor Name"
                required
                value={form.getFieldValue("vendor")}
                onChange={(value) => form.setFieldValue('vendor', value)}
                options={filteredVendors?.map((vendor) => ({
                  id: vendor.id,
                  value: vendor.id,
                  label: vendor.name
                }))}
              />
              {/* <Select placeholder="Select type">
                {filteredVendors?.map((vendor) => (
                  <Select.Option key={vendor.id} value={vendor.id}>
                    {vendor.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="vendor_invoice_no"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <MaterialLikeInput
                label="Vendor Invoice No"
                required
                value={form.getFieldValue("vendor_invoice_no")}
                onChange={(e) => form.setFieldValue("vendor_invoice_no", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <MaterialLikeInput
                label="Amount"
                required
                value={form.getFieldValue("amount")}
                onChange={(e) => form.setFieldValue("amount", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="container_number"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <MaterialLikeInput
                label="Container No"
                required
                value={form.getFieldValue("container_number")}
                onChange={(e) => form.setFieldValue("container_number", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="booking_number"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <MaterialLikeInput
                label="Booking No"
                required
                value={form.getFieldValue("booking_number")}
                onChange={(e) => form.setFieldValue("booking_number", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              name="due_date"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              {/* {button === "save" ? ( */}
              <MaterialLikeDatePicker
                label="Due Date"
                required
                value={form.getFieldValue("due_date")}
                onChange={(date) => form.setFieldValue("due_date", date)}
                disabled={button !== "save"} // 👈 disables when button is not "save"

              />
              {/* <DatePicker style={{ width: "100%" }} />
               ) : (
                <MaterialLikeDatePicker
                  label="Due Date"
                  required
                  value={form.getFieldValue("due_date")}
                  onChange={(date) => form.setFieldValue("due_date", date)}
                  disabled
                /> 
                // < DatePicker style={{ width: "100%" }} disabled />
              )}*/}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="attachment">
              <Upload
                id="uploadInput"
                action="/upload"
                beforeUpload={() => false}
                listType="picture"
                style={{
                  width: "100%",
                }}
              >
                <Button
                  type="dashed"
                  icon={<UploadOutlined />}
                  style={{
                    width: "100%",
                    border: "1px solid #ccc",
                    padding: 18,
                  }}
                >
                  Upload File
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="description">
              <MaterialLikeTextArea
                label="Description"
                rows={5}
                value={form.getFieldValue("description")}
                onChange={(e) => form.setFieldValue("description", e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          {isSave && (
            <>
              <Col span={4} style={{ textAlign: "right" }}>
                <Form.Item style={{ marginTop: 10, textAlign: "right" }}>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    loading={loading}
                    onClick={() => {
                      setIsSave(false);
                      setButton(null);
                      form.setFieldsValue({ DueDate: dayjs().tz() });
                    }}
                  >
                    Cancel
                  </Button>
                </Form.Item>
              </Col>
              <Col span={4} style={{ textAlign: "right" }}>
                <Form.Item style={{ marginTop: 10, textAlign: "right" }}>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    htmlType="submit"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={8} style={{ textAlign: "right" }}>
            <Form.Item style={{ marginTop: 10, textAlign: "right" }}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() => {
                  setButton("save");
                  setIsSave(true);
                }}
                loading={loading}
              >
                Save For Future Payment
              </Button>
            </Form.Item>
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Form.Item style={{ marginTop: 10, textAlign: "right" }}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                htmlType="submit"
                onClick={() => setButton("pay")}
                loading={loading}
                disabled={isSave}
              >
                Make a Payment
              </Button>
            </Form.Item>
          </Col>
        </div>
      </Form>
    </Modal>
  );
}
export default AddExpense;
